export default __webpack_public_path__ + "static/media/stubbed-system-image.9a6b86bd.png";